import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "rules", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    const email = this.emailTarget.value.trim()
    const rulesAccepted = this.rulesTarget.checked
    const isValid = this.isValidEmail(email) && rulesAccepted

    this.submitTarget.disabled = !isValid
  }

  submit(event) {
    if (this.submitTarget.disabled) {
      event.preventDefault()
      return
    }

    this.submitTarget.disabled = true
    this.submitTarget.value = "Zapisywanie..."
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  emailTargetConnected() {
    this.emailTarget.addEventListener("input", () => this.validate())
  }

  rulesTargetConnected() {
    this.rulesTarget.addEventListener("change", () => this.validate())
  }
}
